export const INACTIVITY_MESSAGE_STORAGE_KEY = 'inactivityMessage';

export const NO_ACCESS_MESSAGE_STORAGE_KEY = 'noAccessMessage';

export const SESSION_ENDED_STORAGE_KEY = 'sessionEndedMessage';

export const SESSION_ENDED_MESSAGE = 'Your session has reached its maximum length and has ended. Please sign in again.';

export const SESSION_REVOKED_MESSAGE = 'Your session has ended. Please sign in again.';
